export class EnvironmentService {
  constructor(
    private _environmentConfigs
  ) {}

  public get(name) {
    return this._environmentConfigs[name]
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/environment/environment.service.ts